
export class TemplateComponentType {

  constructor(
    public code: string
  ) {}

}

